module.exports = __webpack_public_path__ + "static/media/inprogress.74bbaa37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Svgs/import-status-icons/inprogress.svg
// module id = 7679
// module chunks = 0